import actions from './constants';

export const showSaveToken = (code, category) => ({
  type: actions.SHOW_SAVE_TOKEN,
  code,
  category,
});

export const hideSaveToken = () => ({
  type: actions.HIDE_SAVE_TOKEN,
});

export const updateActiveTokenProperties = (properties) => ({
  type: actions.UPDATE_ACTIVE_TOKEN_PROPERTIES,
  properties,
});

export const fetchTokens = (category, page, pageSize, append) => ({
  type: actions.FETCH_TOKENS,
  category,
  page,
  pageSize,
  append,
});

export const refreshTokens = (category, page) => ({
  type: actions.REFRESH_TOKENS,
  category,
  page,
});

export const toggleTokenSelected = (code, category) => ({
  type: actions.TOGGLE_TOKEN_SELECTED,
  code,
  category,
});

export const toggleTokensSelected = (category, selected) => ({
  type: actions.TOGGLE_TOKENS_SELECTED,
  category,
  selected,
});

export const updateTokensFilter = (category, value) => ({
  type: actions.UPDATE_TOKENS_FILTER,
  category,
  value,
});

export const updateTokensFlags = (category, activeFlag, expiredFlag, systemFlag) => ({
  type: actions.UPDATE_TOKENS_FLAGS,
  category,
  activeFlag,
  expiredFlag,
  systemFlag,
});

export const showTokens = (
  category,
  append,
  pageSize,
  results,
  resultsCount,
  totalPages,
  currentPage,
  jwtCode,
  jwt,
) => ({
  type: actions.SHOW_TOKENS,
  category,
  append,
  pageSize,
  results,
  resultsCount,
  totalPages,
  currentPage,
  jwtCode,
  jwt,
});

export const showTokensError = (category, error) => ({
  type: actions.SHOW_TOKENS_ERROR,
  category,
  error,
});

export const closeTokens = ({ category }) => ({
  type: actions.CLOSE_TOKENS,
  category,
});

export const createToken = () => ({
  type: actions.CREATE_TOKEN,
});

export const newToken = (result) => ({
  type: actions.NEW_TOKEN,
  result,
});

export const newTokenError = (error) => ({
  type: actions.NEW_TOKEN_ERROR,
  error,
});

export const confirmTokenDeletion = (category, code) => ({
  type: actions.SHOW_DELETE_TOKEN,
  category,
  code,
});

export const confirmTokensDeletion = (category) => ({
  type: actions.SHOW_DELETE_TOKENS,
  category,
});

export const hideDeleteToken = () => ({
  type: actions.HIDE_DELETE_TOKEN,
});

export const confirmTokenRevoke = (category, code) => ({
  type: actions.SHOW_DISABLE_TOKEN,
  category,
  code,
});

export const confirmTokensRevoke = (category) => ({
  type: actions.SHOW_DISABLE_TOKENS,
  category,
});

export const hideDisableToken = () => ({
  type: actions.HIDE_DISABLE_TOKEN,
});

export const deleteToken = (items, category) => ({
  type: actions.DELETE_TOKEN,
  items,
  category,
});

export const destroyToken = (items) => ({
  type: actions.DESTROY_TOKEN, items,
});

export const destroyTokenError = (items) => ({
  type: actions.DESTROY_TOKEN_ERROR, items,
});

export const disableToken = (items, category) => ({
  type: actions.DISABLE_TOKEN,
  items,
  category,
});

export const disableTokenSuccess = (items) => ({
  type: actions.DISABLE_TOKEN_SUCCESS, items,
});

export const disableTokenError = (items) => ({
  type: actions.DISABLE_TOKEN_ERROR, items,
});
